/**
 * Aktif sayfa türü tracker — OTA aktivasyon zamanlaması için.
 *
 * promo/pairing sayfasında SW update hemen aktive edilir (fiyat gösterilmiyor);
 * symbol sayfasında 60sn beklenir veya promo'ya geçişle aktive olur.
 *
 * Memory: decision_pwa_resilience.md §5
 */
export type PageKind = 'promo' | 'symbol' | 'pairing' | 'fatal' | 'unknown';

class PageState extends EventTarget {
    private _current: PageKind = 'unknown';

    get current(): PageKind {
        return this._current;
    }

    set(p: PageKind): void {
        if (this._current === p) return;
        this._current = p;
        this.dispatchEvent(new CustomEvent('change', { detail: p }));
    }
}

export const pageState = new PageState();
